if ($('#navigation').length) {
    $('#navigation .navigation-in').append('<div class="superContact"></div>');
    $('.navigation-in .superContact').append(
        $("footer#footer .contact-box li span.tel").closest("li").clone().addClass("tel"),
    );
    $('.navigation-in .superContact').append(
        $("footer#footer .contact-box li span.mail").closest("li").clone().addClass("mail"),
    );

    $(".navigation-in .superContact span.mail").append(`<span class="info">${emailInfo}</span>`)
    $(".navigation-in .superContact span.tel").append(`<span class="info">${telefonInfo}</span>`)

    if (!$(".navigation-in .superContact a[data-target=login]").length) {
        $('.navigation-in .superContact').append($('.responsive-tools a[data-target=login]').first().clone());
    }
    $('.navigation-in .superContact').append($('.top-navigation-bar-menu').clone());
}

